import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { CopyService } from '@amfam/shared/utility/shared-services';
import { DsModalService } from '@amfam/ui-kit';

@Component({
  selector: 'ds-category-selection-list',
  templateUrl: './category-selection-list.component.html',
  styleUrls: ['./category-selection-list.component.scss'],
  standalone: false
})
export class CategorySelectionListComponent implements OnInit {
  @Input() form: UntypedFormGroup;

  @Input() state: string;

  @Output() checklistUpdateEvent = new EventEmitter();

  categories = this.copyService.getCopy('policy.newVehicleAntiTheftCategories');

  public helpModal = 'helpModal';

  public header: string;

  public body: string;

  constructor(
    private modalService: DsModalService,
    private copyService: CopyService
  ) {}

  ngOnInit(): void {
    if (this.state === this.copyService.getCopy('policy.category4FilteredState')) {
      this.categories = this.categories.filter(category => category.id !== 'category4');
    }
    this.categories.forEach(category => {
      this.form.addControl(category.id, new UntypedFormControl(''));
    });
  }

  toggleOption(update) {
    const { value } = this.form.controls[update.id];
    this.form.controls[update.id].setValue(!value);
    this.checklistUpdateEvent.emit(update);
  }

  openModal(category) {
    const data = this.copyService.getCopy('policy.antiTheftModals');

    this.header = data[this.state].header[category.id];
    this.body = data[this.state].body[category.id];
    this.modalService.open(this.helpModal);
  }
}
